import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/search.svg` */
export const SearchIcon = createTripletGlyphIcon('SearchIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.98193 1.84973C9.5556 1.97979 11.6027 4.10603 11.603 6.70911L11.5962 6.96008C11.5435 7.99709 11.165 8.94789 10.562 9.71399L13.9829 13.2218C14.195 13.4393 14.1906 13.788 13.9731 14.0001C13.7558 14.2119 13.4078 14.2074 13.1958 13.9904L9.78857 10.4962C8.9527 11.1704 7.88993 11.5753 6.73193 11.5753L6.48096 11.5685C3.90753 11.4379 1.86084 9.31215 1.86084 6.70911C1.86118 4.02232 4.04216 1.84404 6.73193 1.84387L6.98193 1.84973ZM6.73193 2.94348C4.64853 2.94365 2.96079 4.63097 2.96045 6.70911C2.96045 8.78753 4.64832 10.4746 6.73193 10.4747C8.8156 10.4746 10.5024 8.78757 10.5024 6.70911C10.5021 4.63094 8.81539 2.94358 6.73193 2.94348Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5835 2.09576C10.6098 2.09576 13.0639 4.54638 13.064 7.5694L13.0562 7.85162C12.9959 9.03729 12.5568 10.1224 11.8589 10.9913L15.7397 14.9698C15.9517 15.1873 15.9474 15.5361 15.73 15.7481C15.5126 15.9601 15.1637 15.9557 14.9517 15.7383L11.0864 11.7755C10.1365 12.5657 8.9164 13.043 7.5835 13.043C4.55723 13.0429 2.104 10.5924 2.104 7.5694C2.10407 4.54647 4.55727 2.09591 7.5835 2.09576ZM7.5835 3.19537C5.16364 3.19552 3.20368 5.15513 3.20361 7.5694C3.20361 9.98372 5.1636 11.9433 7.5835 11.9434C10.0035 11.9434 11.9634 9.98382 11.9634 7.5694C11.9633 5.15503 10.0035 3.19537 7.5835 3.19537Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4585 2.81277C14.3188 3.00839 17.3882 6.19713 17.3882 10.1018L17.3794 10.4768C17.3005 12.0328 16.7326 13.4594 15.8276 14.6087L21.0112 19.9231C21.3004 20.2196 21.2941 20.6945 20.9976 20.9837C20.701 21.2729 20.2262 21.2675 19.937 20.971L14.7827 15.6858C13.512 16.7541 11.8733 17.3996 10.0825 17.3997L9.70654 17.3899C5.97046 17.2009 2.97499 14.2088 2.78564 10.4768L2.77588 10.1018C2.77588 6.07108 6.04733 2.80301 10.0825 2.80301L10.4585 2.81277ZM10.0825 4.30301C6.8742 4.30301 4.27588 6.90106 4.27588 10.1018C4.27614 13.3024 6.87436 15.8997 10.0825 15.8997C13.2905 15.8995 15.8879 13.3023 15.8882 10.1018C15.8882 6.90115 13.2907 4.30316 10.0825 4.30301Z"
        fill="currentColor"
      />
    </svg>
  ),
});
